const algoliaSearchHandler = (() => {
	let queries = [];
	let timer = null;
	const requestMap = new Map();
	const searchClient = algoliasearch(
		globalConfig.algoliaAppId,
		globalConfig.algoliaSearchApiKey,
	);
	return {
		search(query) {
			return new Promise((resolve, reject) => {
				if (isBot()) {
					console.log("Bot detected, skipping Algolia search.");
					return resolve([]);
				}

				const requestKey = `${query.indexName}:${requestMap.size}`;
				if (!requestMap.has(requestKey)) {
					requestMap.set(requestKey, []);
				}
				requestMap.get(requestKey).push(resolve);

				queries.push(query);
				if (timer) {
					clearTimeout(timer);
				}

				timer = setTimeout(() => {
					if (queries.length === 0) return;

					searchClient
						.multipleQueries(queries)
						.then((response) => {
							response.results.forEach((result, i) => {
								const key = `${result.index}:${i}`;

								if (requestMap.has(key)) {
									requestMap.get(key).forEach((resolveFn) => resolveFn(result));
									requestMap.delete(key);
								}
							});
						})
						.catch((error) => {
							reject(error);
						})
						.finally(() => {
							queries = [];
							timer = null;
						});
				}, 200);
			});
		},
	};
})();
